import React, { useState, useEffect } from 'react';
import ENDPOINTS from '../config/apiEndPoints';
import LoadingSpinner from "./LoadingSpinner";

const LiveUpdates = () => {
  const [updates, setUpdates] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        const now = new Date();
        const timestamp = `${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}`;
        const response = await fetch(`${ENDPOINTS.LIVE_UPDATES}?ver=${timestamp}`);
        if (!response.ok) {
          throw new Error('Failed to fetch updates');
        }
        let data = await response.json();
        data = data.Latest;
        // Assuming the API returns an array of updates
        // If the structure is different, adjust the mapping accordingly
        setUpdates(Array.isArray(data) ? data : [data]);
      } catch (err) {
        console.error('Error fetching updates:', err);
        setError('Failed to load live updates. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUpdates().then();
  }, []);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="election-results-inner live-updates">
      <div className="updates-list">
        {updates.length > 0 ? (
          updates.map((update, index) => (
            <div key={index} className={`update-item ${update?.front.toLowerCase()}-item`}>
              <div className="up-time">
                {update?.time ?
                  update.time
                  :
                  new Date().toLocaleTimeString('en-IN', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true
                  })
                }
              </div>
              <div className="up-content">
                {update?.url.trim() !== '' && update?.url.trim() !== '#' && update?.url.trim() !== 'https://www.mathrubhumi.com/' ? (
                  <a href={update.url} target="_blank" rel="noopener noreferrer">
                    {update?.news || ''}
                  </a>
                ) : (
                  update?.news || ''
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="no-updates">No updates available at the moment.</div>
        )}
      </div>
    </div>
  );
};

export default LiveUpdates;